<script lang="ts" setup>
import { useI18n } from "vue-i18n";

const model = defineModel<boolean>();

const props = withDefaults(
  defineProps<{
    type?:
      | "is-primary"
      | "is-link"
      | "is-info"
      | "is-success"
      | "is-warning"
      | "is-danger"
      | "is-default";
    light?: boolean;
    duration?: number;
    autoClose?: boolean;
  }>(),
  {
    type: "is-default",
    light: false,
    duration: 4000,
    autoClose: true
  }
);

const emit = defineEmits(["close"]);
const { t } = useI18n();
</script>

<template>
  <b-notification
    v-model="model"
    :type="props.type"
    :duration="duration"
    :aria-close-label="t('designSystem.notification.close')"
    class="container-notification"
    :auto-close="autoClose"
    @close="() => emit('close')"
  >
    <slot />
  </b-notification>
</template>

<style lang="scss" scoped>
.container-notification {
  margin: auto;
  width: 100%;
}
</style>
